<template>
  <div class="cable-edges-container">
    <Overlay :show="eqpsLoading">
      <div class="button-group">
        <button
          class="edge-button"
          :class="{ active: eqp1, danger: !eqp1 }"
          @click="setMapPosition()"
        >
          <strong>Ponta A -</strong>
          <span>{{ eqp1 ? eqp1.name : "" }}</span>
        </button>

        <button class="edge-button center">
          <img
            class="cable-icon"
            src="../../../assets/img/map/cable.png"
            alt="Cable"
          />
        </button>

        <button
          class="edge-button"
          :class="{ active: eqp2, danger: !eqp2 }"
          @click="setMapPosition(true)"
        >
          <strong>Ponta B -</strong>
          <span>{{ eqp2 ? eqp2.name : "" }}</span>
        </button>
      </div>
    </Overlay>
  </div>
</template>

<script>
import { eqpEdgesPath } from "../../../router/ApiPaths";
import request from "../../../request/request";
// import { minimizeAll } from "../../../components/extra/HideModals";
import { sendMapAction, centerMapPoint } from "../../../components/MessageBus";
import {
  isFolderOpen,
  openFolderControl,
} from "../../../components/extra/FolderControl";
import Overlay from "../../../components/extra/Overlay.vue";

export default {
  name: "CableEdges",
  extends: request,
  components: { Overlay },
  props: ["cableId", "cable", "folderId"],
  data() {
    return {
      eqp1: "",
      eqp2: "",
      eqpsLoading: false,
    };
  },
  watch: {
    cableId: function () {
      this.loadEqps();
    },
    folderId: function () {
      this.loadEqps();
    },
  },
  mounted() {
    // Load data when component is mounted if IDs are available
    if (this.cableId && this.folderId) {
      this.loadEqps();
    }
  },
  methods: {
    setMapPosition(end) {
      let point;

      if (!end) {
        point = {
          lat: this.cable.coordinates[0][1],
          long: this.cable.coordinates[0][0],
        };
        this.openFolder(this.eqp1);
      } else {
        point = {
          lat: this.cable.coordinates[this.cable.coordinates.length - 1][1],
          long: this.cable.coordinates[this.cable.coordinates.length - 1][0],
        };
        this.openFolder(this.eqp2);
      }

      sendMapAction(centerMapPoint, point);
      // minimizeAll();
    },
    loadEqps() {
      if (this.cableId && this.folderId) {
        this.eqpsLoading = true;
        this.get(eqpEdgesPath(this.folderId, this.cableId))
          .then((data) => {
            this.eqp1 = data.eqp1;
            this.eqp2 = data.eqp2;
          })
          .finally(() => {
            this.eqpsLoading = false;
          });
      }
    },
    openFolder(eqp) {
      if (eqp && eqp.folderId) {
        if (isFolderOpen(eqp.folderId) === 0) {
          openFolderControl({
            id: eqp.folderId,
            name: eqp.folderName,
            status: eqp.folderStatus,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.cable-edges-container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-group {
  display: flex;
  align-items: stretch;
  width: fit-content;
  margin: 0 auto;
}

.edge-button {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ddd;
  background-color: #28a745;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.edge-button:first-child {
  border-radius: 0.25rem 0 0 0.25rem;
}

.edge-button:last-child {
  border-radius: 0 0.25rem 0.25rem 0;
}

.edge-button.center {
  background-color: #f8f9fa;
  border-left: none;
  border-right: none;
}

.edge-button.active {
  font-weight: bold;
}

.edge-button.danger {
  background-color: #dc3545;
}

.cable-icon {
  height: 1.25rem;
  width: auto;
}
</style>
